"use client";

// Shared between the COMMAND page chat list and the Talk to Command sidebar's
// History tab — both lists must read the same at a glance.

import type { ProtoChatSession } from "../prototype/types";

/** Working / unread / read at a glance: pulsing dot while a reply is being
 *  worked on, solid dot once it's done but not yet opened, outline when read. */
export function ChatStatusDot({ session }: { session: ProtoChatSession }) {
  const working = session.messages.some((message) => message.pending);
  if (working) {
    return (
      <span
        title="Working…"
        className="size-2 shrink-0 animate-pulse rounded-full bg-primary"
      />
    );
  }
  if (session.unread) {
    return (
      <span
        title="Done — not read yet"
        className="size-2 shrink-0 rounded-full bg-primary"
      />
    );
  }
  return (
    <span
      title="Read"
      className="size-2 shrink-0 rounded-full border border-muted-foreground/40"
    />
  );
}
